"use client";

import { Text } from "@/components/ui/text";

import { useColorItem, UseColorItemProps } from "./use-color-item";
import ColorItemContent from "./color-item.content";

export type ColorItemProps = UseColorItemProps;

function ColorItem(props: ColorItemProps) {
  const {
    className,
    styles,
    data: { name, label, value, pantone },
    textColor,
    backgroundColor,
    sectionName,
    copyToClipboard,
    style,
  } = useColorItem(props);

  return (
    <div
      className={styles.base({ className })}
      style={{ backgroundColor, ...style }}
      data-section-name={sectionName}
    >
      <Text
        tag="h3"
        size="bodyLarge"
        className={styles.title()}
        style={{ color: textColor }}
      >
        {name}
      </Text>

      <div className={styles.content()}>
        <ColorItemContent
          label={label}
          value={value}
          textColor={textColor}
          styles={styles}
          onCopyToClipboard={copyToClipboard}
        />
        {pantone && (
          <ColorItemContent
            label="pantone"
            value={pantone}
            textColor={textColor}
            styles={styles}
            onCopyToClipboard={copyToClipboard}
          />
        )}
      </div>
    </div>
  );
}

export default ColorItem;
